import { SCREEN_SM } from 'shared/consts/styleValues';
import { InputProps, sharedStyles } from 'shared/ui/Inputs/Input';
import styled from 'styled-components';

interface Container {
	$left?: string;
}

export const Container = styled.div<Container>`
	position: relative;
	cursor: pointer;
  @media (min-width:${SCREEN_SM}px){
    left: ${props => props.$left || 'initial'};
  }
  @media (max-width:${SCREEN_SM}px){
    right: 0;
  }
`;

export const DayOfWeek = styled.div`
	text-transform: uppercase;
`;

export const DateText = styled.div`
	color: black;
`;

export const Input = styled.input<InputProps>`
	${sharedStyles}
`;
